import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CartTopButtons from "./display/CartTopButtons";
import CartOrderText from "./display/CartOrderText";
import CartList from "./list/CartList";
import { useSnackbarMessages } from "../../yoello-lib/modules/components/snackbar/SnackbarContext";
import { checkAbvContainsFood } from "../../utils/checkAbvContainsFood";
import { getCartSubTotal } from "../../utils/pricingCalculator";
import { _ChangeRedirect, _resetCart, _ShowUp } from "../../redux/actions";
import { useHistory } from "react-router-dom";
import CartTotalCount from "./display/CartTopPrice";
import { useAuth0 } from "../../yoello-lib/modules/auth/Auth0";
import { PAYMENT } from "../../constants/URL.const";
import Styles from "./shopList.module.scss";
import Button from "../Widgets/Button";
import { ReactComponent as CartSVG } from "../../imges/cart_new.svg";
import T from "i18n-react";
import { SelectedOrderType } from "../Payment/types.d";
import UnmountDrawerWrapper from "../Drawer/UnmountDrawerWrapper";
import useCurrency from "../../yoello-lib/modules/localisation/useCurrency";
// import { useCartBack } from "./useCartBack";
import { useVenueOpen } from "../../customHooks/useVenueOpen";
import { useGetLastOrder } from "../../customHooks/useGetLastOrder";

interface IShoppingCartListProps {
  area: boolean;
  canOnlyView: boolean;
}

function ShoppingCartList({ area, canOnlyView }: IShoppingCartListProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { formatCurrency } = useCurrency();
  const threshold = 200; //required min distance traveled to be considered swipe
  const [touchStartLocation, setTouchStartLocation] = useState(null);
  const [cartSubTotal, setCartSubTotal] = useState<number>(0);
  const cartItems = useSelector((state: any) => state.Cart);
  const group = useSelector((state: any) => state.Group);
  const Venue = useSelector((state: any) => state.Venue);
  const SelectedMenuType = useSelector((state: any) => state.SelectedMenuType);
  const formattedMinimumDelivery = formatCurrency(Venue.min_delivery_price);
  const history = useHistory();
  const { setRedirectURLs } = useAuth0()!;
  const dispatch = useDispatch();
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  // const isCartOpen = useCartBack();
  const isVenueOpen = useVenueOpen();
  const { lastOrder, addOrderToCart } = useGetLastOrder();

  useEffect(() => {
    setCartSubTotal(getCartSubTotal(cartItems));
  }, [cartItems]);

  function onOpenCart() {
    setIsOpen((prevOpen) => {
      return !prevOpen;
    });
  }
  function getItemCount() {
    let counter = 0;
    cartItems.forEach((cartItem: any) => {
      counter += cartItem.itemCount;
    });
    return counter;
  }

  async function onConfirmationClick(e) {
    e.stopPropagation();
    // First: Cart Empty
    if (cartItems.length === 0) {
      sendSnackbarMessage(
        T.translate("ShopCart.Errors.YourCartIsEmpty") as string,
        "error"
      );
      return;
    }

    // Second: Min delivery value check
    if (
      SelectedMenuType === SelectedOrderType.DELIVERY &&
      cartSubTotal < Venue.min_delivery_price
    ) {
      sendSnackbarMessage(
        T.translate("ShopCart.Errors.CartLessThan", {
          price: formattedMinimumDelivery,
        }) as string,
        "error"
      );
      return;
    }

    // Third: ABV check
    if (
      area &&
      !checkAbvContainsFood(cartItems, group?.group_abv_food_threshold)
    ) {
      const minFoodPrice = formatCurrency(group?.group_abv_food_threshold);
      sendSnackbarMessage(
        T.translate("ShopCart.Errors.MinFoodItems", {
          price: minFoodPrice,
        }) as string,
        "error"
      );
      return;
    }
    /**Is venue open  */
    if (!isVenueOpen) {
      sendSnackbarMessage(
        T.translate("ShopCart.Errors.VenueClosed") as string,
        "error"
      );
      return;
    }
    dispatch(_ShowUp(false));
    setRedirectURLs(PAYMENT);
    dispatch(_ChangeRedirect(getRedirectPlaceURL()));
    history.push("/payment", {
      area: window.location.pathname.split("/")[1] === "g",
    });
  }
  function addShadowOnScroll() {
    // const distanceY = window.pageYOffset || document.documentElement.scrollTop,
    //   shrinkOn = 200,
    const containerEl = document.getElementById("shopListContainerId")!;
    const detailsElement = document.getElementById("cartItemsId")!;
    if (detailsElement.scrollTop > 5) {
      containerEl.classList.add(Styles.contentSlideToTop);
    } else {
      containerEl.classList.remove(Styles.contentSlideToTop);
    }
    if (
      detailsElement.offsetHeight + detailsElement.scrollTop >=
      detailsElement.scrollHeight
    ) {
      containerEl.classList.remove(Styles.contentSlideToBottom);
    } else containerEl.classList.add(Styles.contentSlideToBottom);
  }

  function handleTouchStart(e) {
    const firstTouchEvent = e.touches[0];
    const location = {
      x: firstTouchEvent.clientX,
      y: firstTouchEvent.clientY,
    };
    setTouchStartLocation(location);
  }
  function handleTouchEnd(e) {
    const firstTouchEvent = e.changedTouches[0];
    const location = {
      x: firstTouchEvent.clientX, //get the location of the end of the touch
      y: firstTouchEvent.clientY,
    };
    const differences = {
      x: location.x - touchStartLocation.x, //find the difference from the start to the end touch
      y: location.y - touchStartLocation.y,
    };
    if (differences.y > threshold && location.y > 0) {
      onOpenCart();
    }
  }
  const getDeletedItems = () => {
    const state = history.location.state as { deletedItems: any[] };
    if (state?.deletedItems) {
      return state.deletedItems;
    }
  };
  return (
    <div
      className={Styles.shoppingCartContainer}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className={Styles.shoppingCartBtn}
        onClick={onOpenCart}
        data-component-name="ShoppingCartButton"
      >
        <CartOrderText
          cartLength={cartItems.length || 0}
          totalPrice={cartSubTotal}
        />
        <CartTopButtons
          isOpen={isOpen}
          cartLength={cartItems.length || 0}
          onConfirmationClick={onConfirmationClick}
          lastOrder={lastOrder}
          addOrderToCart={addOrderToCart}
        />
        <CartTotalCount isOpen={isOpen} cartItems={cartItems} />
      </div>
      {
        <div
          className={`${Styles.shoppingCartDrawer} ${
            isOpen && Styles.openCart
          }`}
          id="shoppingCartDrawer"
        >
          <div className={Styles.myCart}>
            <div className={Styles.shopListContainer} id="shopListContainerId">
              <>
                <div className={Styles.header}>
                  <div
                    className={Styles.lineBar}
                    onClick={() => onOpenCart()}
                  />
                </div>
                <div className={Styles.cartDetails}>
                  <div>
                    <div>
                      <CartSVG />
                      <p>{T.translate("ShopCart.MyCart")}</p>
                    </div>
                    <Button
                      iconClassName="consumer-close"
                      isHeaderBtn
                      className={Styles.closeDrawer}
                      onClick={() => onOpenCart()}
                    />
                  </div>
                  <div>
                    <div>
                      <span className={Styles.dot}></span>
                      <T.p
                        className={Styles.cartItemsCount}
                        data-component-name={"cartItemsCount"}
                        text={{
                          key: `buttons.Items`,
                          Count: getItemCount(),
                        }}
                      />
                    </div>
                    <div>
                      <Button
                        title={"EmptyCart"}
                        className={Styles.emptyCart}
                        onClick={() => {
                          onOpenCart();
                          dispatch(_resetCart());
                        }}
                        dataComponentName="ShoppingCartEmptyButton"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={Styles.cartItems}
                  onScroll={addShadowOnScroll}
                  id="cartItemsId"
                >
                  <div className={Styles.shadowTop}></div>
                  <CartList
                    cartItems={cartItems}
                    deletedItems={getDeletedItems()}
                    onOpenCart={onOpenCart}
                    isOpen={isOpen}
                  />
                  <div className={Styles.shadowBottom}></div>
                </div>
              </>
            </div>
          </div>
        </div>
      }
      <div
        id="backgroundMaskId"
        className={`${Styles.drawerMask} ${isOpen && Styles.maskBackground}`}
        onClick={onOpenCart}
      ></div>
      {isOpen ? (
        <UnmountDrawerWrapper
          closeDrawer={() => {
            setIsOpen(false);
          }}
        >
          <></>
        </UnmountDrawerWrapper>
      ) : null}
    </div>
  );
}

function getRedirectPlaceURL() {
  if (window.location.pathname.split("/")[1] === "g") {
    return "PaymentA";
  } else if (window.location.pathname.split("/")[1] === "v") {
    return "PaymentV";
  }
}

export default ShoppingCartList;
